import React from "react";
import { Button, ButtonGroup, Dropdown, DropdownButton, FormCheck } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import { DBMaterialType } from "../database_types";

export function StolarzFormOptionsDropdown({ showPreview, setShowPreview, showSummaryPreview, setShowSummaryPreview, defaultEdgeCode, setDefaultEdgeCode, edgesDB, handleShowSaveModal, handleShowLoadModal }: {
    showPreview: boolean, setShowPreview: (value: boolean) => void,
    showSummaryPreview: boolean, setShowSummaryPreview: (value: boolean) => void,
    defaultEdgeCode: string, setDefaultEdgeCode: (value: string) => void, edgesDB: DBMaterialType[], handleShowSaveModal: any, handleShowLoadModal: any
}) {

    return <DropdownButton autoClose="outside" as={ButtonGroup} title="⚙" id="bg-nested-dropdown" variant="secondary">
        <Dropdown.Item eventKey={1} as={Button}>
            <FormCheck>
                <FormCheck.Label>Pokazuj podgląd
                    <FormCheck.Input checked={showPreview} type="checkbox" onChange={(e) => setShowPreview(e.currentTarget.checked)} />
                </FormCheck.Label>
            </FormCheck>
        </Dropdown.Item>
        <Dropdown.Item eventKey={11} as={Button}>
            {/* <Row > */}
            <FormCheck>
                <FormCheck.Label>Pokazuj podsumowanie
                    <FormCheck.Input checked={showSummaryPreview} type="checkbox" onChange={(e) => setShowSummaryPreview(e.currentTarget.checked)} />
                </FormCheck.Label>
            </FormCheck>
        </Dropdown.Item>
        <Row>
            <DropdownButton as={ButtonGroup} title={`Domyślna krawędź: ${defaultEdgeCode}`} id="default-edge-dropdown" variant="secondary" onSelect={(ev) => ev && setDefaultEdgeCode(ev)}>
                {edgesDB.map((edge) => <Dropdown.Item eventKey={edge.code}>{edge.code}</Dropdown.Item>)}
            </DropdownButton>
        </Row>
        <Dropdown.Divider></Dropdown.Divider>
        <Dropdown.Item eventKey={2} as={Button}>
            <Row>
                <Button onClick={handleShowSaveModal}>
                    🖫 Zapisz całe zamówienie na tym komputerze
                </Button>
            </Row>
        </Dropdown.Item>
        <Dropdown.Item eventKey={3} as={Button}>
            <Row>
                <Button onClick={handleShowLoadModal} variant='secondary'>
                    🗁 Załaduj zapisane zamówienie
                </Button>
            </Row>
        </Dropdown.Item>
    </DropdownButton>
}